import {
    CircularProgress,
    Container,
    IconButton,
    Link,
    List,
    ListItem,
    ListItemSecondaryAction,
    Paper,
    Tooltip,
    Typography,
    Button,
    Box,
    Grid,
    Card, CardContent, CardHeader, Tab, Tabs
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DownloadIcon from '@mui/icons-material/Download';
import ShareIcon from '@mui/icons-material/Share';
import AttachmentApi from "../../../http/v1_apis/AttachmentApi";
import { BusinessScoreRequestStatus } from "../../../util/Constant";
import BorrowerFiListingDialog from "../../business_score_request/ShareScoreWithfiDialogComponent";
import SystemDefault from "../../../util/SystemDefault";
import { SnackBarActions } from "../../../store/SnackBarSlice";
import { SnackBarMessageType } from "../../../util/Constant";
import PropTypes from 'prop-types';
import { GridDragIcon } from "@mui/x-data-grid";


const GBSViewDetailGSTINComponent = (props) => {
    const currentOrg = useSelector((state) => state.currentOrg);
    const pan = currentOrg?.organisation?.taxIdentifier;
    const [orgMap, setOrgMap] = useState({});
    const dispatch = useDispatch();
    const [tabValue, setTabValue] = React.useState(0);


    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    function CustomTabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box sx={{ p: 3 }}>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }

    CustomTabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }


    return (
        <React.Fragment>
            <Grid container spacing={2} direction="row" >
                {Object.values(props.gstins).map((gstin) => {
                    return (<Grid item xs={12} sm={6} md={3} key={gstin.id}>
                        <Card variant="outlined">
                            <CardContent>
                                <Grid container spacing={1.5}>
                                    <Grid item container spacing={2}>
                                        <Grid item sx={{ width: 150 }} color="text.secondary">
                                            GSTIN :
                                        </Grid>
                                        <Grid item>
                                        <Tooltip title={<div>{gstin.gstin}</div>} arrow>
                                            <Typography>{gstin.gstin}</Typography>
                                        </Tooltip>
                                        </Grid>
                                    </Grid>
                                    <Grid item container spacing={2}>
                                        <Grid item sx={{ width: 150 }} color="text.secondary">
                                            Username :
                                        </Grid>
                                        <Grid item>
                                            {gstin.gstinUsername}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                )})}
            </Grid>

        </React.Fragment>
    );
};

export default GBSViewDetailGSTINComponent;
